<template>
    <div ref="unitEntryBodyRepairByInsurance" style="min-height: 500px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data() {
            return {
                chart: null,
            }
        },
        props: ['data'],
        mounted() {
            this.createChart();
            this.generateData();
        },
        watch: {
            data: {
                deep: true,
                handler: 'generateData'
            }
        },
        methods: {
            generateData() {
                let length = this.chart.data.length;
                // let compiledData = [];

                // let data = this.data;
                // if (data && data.length > 0) {

                // } else {
                //     compiledData = [{


                //     }]
                // }

                this.chart.addData(this.data && this.data.length > 0 ? this.data : [{
                    insurance_name: 'No Data',
                    heavy_dmg: 0,
                    medium_dmg: 0,
                    light_dmg: 0
                }], length)
            },
            createChart() {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                this.chart = am4core.create(this.$refs.unitEntryBodyRepairByInsurance, am4charts.XYChart);
                // this.chart.padding(40, 40, 40, 40);

                let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = "insurance_name";
                categoryAxis.renderer.minGridDistance = 1;
                categoryAxis.renderer.inversed = true;
                categoryAxis.renderer.grid.template.disabled = true;

                let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;

                this.createSeries("light_dmg", "Light Damage");
                this.createSeries("medium_dmg", "Medium Damage");
                this.createSeries("heavy_dmg", "Heavy Damage");

                // Legend
                this.chart.legend = new am4charts.Legend();
            },
            createSeries(field, name) {

                //Create Series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.name = name;
                series.dataFields.valueX = field;
                series.dataFields.categoryY = "insurance_name";
                // series.tooltipText = "{valueX.value}"
                // series.columns.template.strokeOpacity = 0;
                // series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryY}: {valueX}";
                // series.columns.template.fillOpacity = .8;

                // Configure columns
                series.columns.template.width = am4core.percent(60);
                series.columns.template.fillOpacity = .8;
                series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryY}: {valueX}";

                // Make it stacked
                series.stacked = true;

                // let labelBullet = series.bullets.push(new am4charts.LabelBullet())
                // labelBullet.label.horizontalCenter = "left";
                // labelBullet.label.dx = 10;
                // labelBullet.label.text = "[bold]{name}[/]\n[font-size:14px]{categoryY}: {valueX}";
                // labelBullet.locationX = 1;

                return series;
            }
        }
    }
</script>

<style scoped>

</style>